import styled from '@emotion/styled';
import media from '@shared/mediaQuery';

const FursysInquiryButtonStyle = styled('div')`
  .openPopup {
    background-color: #ff5500;
    font-family: 'Pretendard-Bold';
    letter-spacing: -0.3px;
    position: fixed;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    ${media.desktop} {
      cursor: pointer;
      bottom: 50px;
      right: 50px;
      width: 120px;
      height: 120px;
      font-size: 24px;
    }
    ${media.mobile} {
      width: 64px;
      height: 64px;
      right: 20px;
      bottom: 20px;
      font-size: 14px;
    }
  }

  .fursysQuestionaction--popup-wrap {
    position: fixed;
    z-index: 2000;
    ${media.desktop} {
      right: 50px;
      bottom: 50px;
      width: 400px;
    }
    ${media.mobile} {
      width: 100%;
      height: 100%;
      background-color: rgba(34, 34, 34, 0.7);
      overflow-y: auto;
      top: 0;
      left: 0;
    }
  }
`;

export default FursysInquiryButtonStyle;
